import { Calendar, DateRangePicker } from 'react-date-range'
import 'react-date-range/dist/styles.css'

export { Calendar, DateRangePicker }
export * from 'react-date-range'
